import * as types from "./changePasswordActionType";

export const changePasswordRequest = (payload) => ({
  type: types.CHANGE_PASSWORD_REQUEST,
  payload,
});

export const changePasswordSuccess = (data) => ({
  type: types.CHANGE_PASSWORD_SUCCESS,
  payload: data,
});

export const changePasswordFailure = (error) => ({
  type: types.CHANGE_PASSWORD_FAILURE,
  payload: error,
});
